import $ from 'jquery';
import _ from 'underscore';
import Backbone from "backbone";
import Chaplin from "chaplin";
import WorkspaceUsagePopupView from "views/workspace/WorkspaceUsagePopupView";
import TrebbleClientAPIHelper from "models/helper/TrebbleClientAPI";
import LocalStorageHelper from "models/helper/LocalStorageHelper";
import ti18n from "i18n!nls/WorkspaceManagei18n";
import RSVP from "rsvp";

const WorkspaceUsagePopupController = Chaplin.Controller.extend({

    initialize: function(options) {
        _.extend(this, Backbone.Events);
        this._parentController = options.parentController;
    },

    getModel: function() {
        return this.model;
    },

    getView: function() {
        return this.view;
    },

    onPopupClosed: function() {
        // Cleanup if needed
    },

    handleBuyMore: function() {
        // Open Stripe billing portal to purchase additional minutes
        const workspaceId = LocalStorageHelper.getInstance().getCurrentWorkspaceId();
        if (!workspaceId) {
            return;
        }

        $.mobile.loading("show");
        TrebbleClientAPIHelper.getInstance().getWorkspaceBillingPortalUrl({
            workspaceId: workspaceId,
        }).then(function(portalUrl) {
            $.mobile.loading("hide");
            if (portalUrl) {
                window.open(portalUrl);
            }
        }).catch(function(error) {
            $.mobile.loading("hide");
            console.error('Failed to open billing portal:', error);
            window.alertErrorMessage(window.getI18n(ti18n, "BILLING_PORTAL_ERROR"));
        });
    },

    _loadUsageData: function() {
        const workspaceId = LocalStorageHelper.getInstance().getCurrentWorkspaceId();
        if (!workspaceId) {
            return RSVP.Promise.resolve(null);
        }

        return TrebbleClientAPIHelper.getInstance().getWorkspaceUsage({
            workspaceId: workspaceId,
        });
    },

    buildModelAndRenderView: function() {
        return this._loadUsageData().then((function(usageData) {
            const params = {
                usage: usageData,
                onBuyMore: this.handleBuyMore.bind(this),
                i18nModule: ti18n
            };

            this.view = new WorkspaceUsagePopupView(params);
            this.listenTo(this.view, "closed", this.onPopupClosed);

            this.view.render();
        }).bind(this)).catch((function(error) {
            console.error('Failed to load workspace usage:', error);

            // Render with null usage data - component will show empty state
            const params = {
                usage: null,
                onBuyMore: this.handleBuyMore.bind(this),
                i18nModule: ti18n
            };

            this.view = new WorkspaceUsagePopupView(params);
            this.listenTo(this.view, "closed", this.onPopupClosed);

            this.view.render();
        }).bind(this));
    }
});

export default WorkspaceUsagePopupController;
